module.exports = __webpack_public_path__ + "img/setup-unconfined-min.bb77d00b.jpg";